import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { useDispatch } from "react-redux";
import groupReducer from "./Reducers/groupReducer";
import categoriesReducer from "./Reducers/categoriesReducer";
import createPostReducer from "./Reducers/createPostReducer";
import userAuthReducer from "./Reducers/userAuthReducer";
import dashboardReducer from "./Reducers/dashboardReducer";
import gcGroupReducer from "./Reducers/gcGroupReducer";
import postReportsReducer from "./Reducers/postReportsReducer";
import blocksReducer from "./Reducers/blocksReducer";
import adminAuthReducer from "../mng/redux/adminAuthReducer";
import createOpinionReducer from "../mng/redux/createOpinionReducer";
import errorReducer from "../mng/redux/errorReducer";

const reducers = combineReducers({
  groups: groupReducer,
  categories: categoriesReducer,
  createPost: createPostReducer,
  userAuth: userAuthReducer,
  dashboard: dashboardReducer,
  gcGroup: gcGroupReducer,
  postReports: postReportsReducer,
  blocks: blocksReducer,
  adminAuth: adminAuthReducer,
  createOpinion: createOpinionReducer,
  mngError: errorReducer
});

const persistConfig = {
  key: "root",
  storage,
  sessionStorage,
  whitelist: [
    "userAuth",
    "groups",
    "categories",
    "postReports",
    "blocks",
    "adminAuth",
    "dashboard"
  ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export const persistor = persistStore(store);
